function Icone({ size = 24, strokeWidth = 2, children, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
    >
      {children}
    </svg>
  );
}
export const BotMessageSquare = ({ size = 24, className }) => (
  <Icone size={size} className={className}>
    <path d="M12 6V2H8" />
    <path d="M15 11v2" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="M20 16a2 2 0 0 1-2 2H8.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 4 20.286V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z" />
    <path d="M9 11v2" />
  </Icone>
);
export const ImagePlus = ({ size = 20, className }) => (
  <Icone size={size} className={className}>
    <path d="M16 5h6" />
    <path d="M19 2v6" />
    <path d="M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5" />
    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
    <circle cx="9" cy="9" r="2" />
  </Icone>
);
export const X = ({ size = 16, className }) => (
  <Icone size={size} className={className}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </Icone>
);
export const ArrowDown = ({ size = 18, className }) => (
  <Icone size={size} className={className}>
    <path d="M12 5v14" />
    <path d="m19 12-7 7-7-7" />
  </Icone>
);
export const ChevronLeft = ({ size = 16, className }) => (
  <Icone size={size} className={className}>
    <path d="m15 18-6-6 6-6" />
  </Icone>
);
export const Plus = ({ size = 16, className }) => (
  <Icone size={size} className={className}>
    <path d="M5 12h14" />
    <path d="M12 5v14" />
  </Icone>
);
export const Pointer = ({ size = 16, className }) => (
  <Icone size={size} className={className}>
    <path d="M22 14a8 8 0 0 1-8 8" />
    <path d="M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2" />
    <path d="M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1" />
    <path d="M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10" />
    <path d="M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15" />
  </Icone>
);
export const Camera = ({ size = 20, className }) => (
  <Icone size={size} className={className}>
    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
    <circle cx="12" cy="13" r="3" />
  </Icone>
);
